// show sorting table 
export const DEFAULT_COLUMN_LABELS: { [key: string]: string } = {
    fieldLongName: 'Field',
    platformLongName: 'Platform',
    wellLongName: 'Well',
    stringShortName: 'Well String',
    stringIndicatorShortName: 'String Indicator',
};